<template>
    <div class="cz2__ai-modal__loading">
        <div class="cz2__modal-popup__header">
            {{ heading }}
        </div>

        <p class="cz2__modal-popup__copy">
            {{ copy }}
        </p>

        <funko-spinner
            :is-ai-modal="true"
        />
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-modal {
            .cz2__ai-modal__loading {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 16px;

                .spinner {
                    margin-top: 64px;
                    animation: spin 4s linear infinite;
                }

                @keyframes spin {
                    from {
                        transform: rotate(0deg);
                    }
                    to {
                        transform: rotate(360deg);
                    }
                }
            }
        }
    }
</style>

<script>
    import FunkoSpinner from '../ui/FunkoSpinner.vue';

    export default {
        components: {
            FunkoSpinner,
        },

        props: {
            heading: {
                type: String,
                default: '',
            },

            copy: {
                type: String,
                default: '',
            },
        },
    };
</script>
